
class DocumentLinkListViewController extends MUIViewController
{
    static newInstance() : DocumentLinkListViewController {
        let vc = new DocumentLinkListViewController("document-link-list-view");
        vc.initWithResource("layout/accounting_entries/DocumentLinkListView.html");
        return vc;
    }

    get preferredContentSize() { return new MIOSize(400, 500); }

    private tableView:UITableView = null;

    private links:BankMovementDocumentLink[] = [];

    viewDidLoad(){
        super.viewDidLoad();

        this.tableView = MUIOutlet(this, "table-view", "UITableView");
        this.tableView.dataSource = this;
    }

    viewWillAppear(animated?:boolean){
        super.viewWillAppear(animated);
        this.tableView.reloadData();
    }

    setLinks(links:BankMovementDocumentLink[]){
        this.links = links ?? [];
        if (this.viewIsLoaded) this.tableView.reloadData();
    }

    numberOfSections(tableView:UITableView) {
        return 1;
    }

    numberOfRowsInSection(tableView:UITableView, section:number) {
        return this.links.length;
    }

    cellAtIndexPath(tableView:UITableView, indexPath:MIOIndexPath) {
        let cell = tableView.dequeueReusableCellWithIdentifier("DocumentLinkCell") as DocumentLinkListCell;
        cell.item = this.links[indexPath.row];
        return cell;
    }
}

class DocumentLinkListCell extends UITableViewCell
{
    private typeLabel:MUILabel = null;
    private conceptLabel:MUILabel = null;
    private legalEntityLabel:MUILabel = null;
    private amountLabel:MUILabel = null;

    awakeFromHTML(){
        this.typeLabel = MUIOutlet(this, "type-lbl", "MUILabel");
        this.conceptLabel = MUIOutlet(this, "concept-lbl", "MUILabel");
        this.legalEntityLabel = MUIOutlet(this, "legal-entity-lbl", "MUILabel");
        this.amountLabel = MUIOutlet(this, "amount-lbl", "MUILabel");

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    set item(link:BankMovementDocumentLink){
        let cf = (MUIWebApplication.sharedInstance().delegate as AppDelegate).currencyFormatter;

        this.typeLabel.text = BankMovementLinkCell.displayNameForLinkedEntity(link.linkedEntityName);
        this.conceptLabel.text = link.concept?.length > 0 ? link.concept : link.linkedEntityName;
        this.legalEntityLabel.text = link.legalEntityName ?? link.legalEntity?.name;
        this.amountLabel.text = cf.stringFromNumber(link.amount);
    }
}
